// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    --intro-tab-bg: #e5edff;
    --intro-tab-color: #001d35;
    --intro-card-radius: 2rem;
    --divider-color: rgba(60, 64, 67, 0.25);

    font-family: Arial, sans-serif;
}

#logo {
    width: 7rem;
    font-size: 1.5rem;
    font-weight: 700;

    span {
        display: inline-block;
        letter-spacing: 1px;
    }
}

.google-blue {
    color: #4285F4;
}
.google-red {
    color: #EA4335;
}
.google-yellow {
    color: #FBBC05;
}
.google-green {
    color: #34A853;
}

#search-wrapper {
    .input-group {
        width: 50vw;
        border-radius: 4rem;
        box-shadow: 0px 2px 8px 0px rgba(60, 64, 67, 0.25);
        input {
            box-sizing: border-box;
            padding-left: 1rem;
            border-top-left-radius: 4rem;
            border-bottom-left-radius: 4rem;
            line-height: 2;
            border-right: 0;
            background: white;
        }

        #button-addon2 {
            border: var(--bs-border-width) solid var(--bs-border-color);
            border-top-right-radius: 4rem;
            border-bottom-right-radius: 4rem;
            border-left: 0;
            #search-icon {
                color: #4285f4;
                margin-right: 1rem;
            }

            &:hover {
                background: none;
            }
        }

        #logo-prepend {
            #basic-addon1 {
                border: none;
                background: none;
                border-top-left-radius: 4rem;
                border-bottom-left-radius: 4rem;

                img {
                    width: 2rem;
                    object-fit: contain;
                }
            }
        }

        input, #button-addon2 {

        }
    }
}

#content-wrapper {
    min-height: 100vh;

    #pills-tab {
        border-bottom: 1px solid var(--divider-color);
        font-weight: 500;

        .nav-link {
            font-weight: 400;
            font-size: 0.9rem;
            text-decoration: none;
            color: #70757a;
            padding-left: 1rem;
            padding-right: 1rem;
            &.active {
                font-weight: 600;
                border-bottom-color: #1f1f1f;
                color: #1f1f1f;
            }
        }
    }

    #pills-tabContent,   #pills-tab {
        padding-left: 9rem;
        padding-right: 9rem;
    }

    .intro-tab {
        border-radius: var(--intro-card-radius);
        background: var(--intro-tab-bg);
        color: var(--intro-tab-color);
        margin-left: 1rem;
        &.active {
            border: 1px solid #001d35;
        }
    }

    #self-intro-tab-content {
        padding-bottom: 2rem;

        .fade:not(.show) {
            display: none !important;
        }

        .active {
            display: block;
        }

        #intro-home {
            border-bottom: 1px solid var(--intro-tab-bg);
        }

        #image-container {
            height: 20rem;
            border-radius: var(--intro-card-radius);
            #image-main, #image-sub {
                width: 50%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            #image-sub {
                img {
                    height: 50%;
                }
            }

            #first-image {
                border-top-left-radius: var(--intro-card-radius);
                border-bottom-left-radius: var(--intro-card-radius);
                border-right: 3px solid white;
            }

            #second-image {
                border-top-right-radius: var(--intro-card-radius);
                border-bottom: 3px solid white;
            }

            #third-image {
                border-bottom-right-radius: var(--intro-card-radius);
            }
        }

        #general-info-container {
            #instagram-wrapper {
                border-radius: var(--intro-card-radius) !important;
                border: 2px solid var(--intro-tab-bg);
                height: 20rem;
                overflow-y: scroll;
                overflow-x: hidden;
                -ms-overflow-style: none;  /* IE and Edge */
                scrollbar-width: none;  /* Firefox */
                > iframe {
                    border: none;
                }
            }
            &::-webkit-scrollbar {
                display: none;
            }
            #card-image {
                width: 100%;
                height: 50%;
                object-fit: cover;
                border-top-left-radius: var(--intro-card-radius);
                border-top-right-radius: var(--intro-card-radius);
            }
        }

        #misc-info-container {
            height: 20rem;

            #age-info {
                margin-right: 0.75rem;
                flex: 1;
            }

            #age-info, #education-info {
                height: calc(50% - 0.75rem);
            }

            #misc-info {
                width: 100%;
                overflow: hidden;
            }
            .info-card {
                width: 50%;
                background: var(--intro-tab-bg);
                border-radius: var(--intro-card-radius);
                margin-bottom: 0.75rem;
                .info-title {
                    font-weight: 500;
                    margin-top: 0;
                    margin-bottom: auto;
                }

                #age-info-years {
                    line-height: 1;
                    font-weight: 600;
                }
                #age-info-dob {
                    line-height: 1;
                    font-weight: 400;
                }
            }
        }

        #intro-home {
            &.active  + #non-overview-content-wrapper{
                #intro-employment {
                    display: block !important;
                    opacity: 1 !important;
                }
            }
        }

        .intro-tab-title {
            font-weight: 400;
        }

        .intro-card-wrapper {
            .intro-card-image-container {
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                max-width: 10rem;
                width: 100%;
                text-align: left;
            }
            .intro-card-image {
                max-width: 10rem;
                width: 100%;
                /*padding: 1rem 2.5rem 0.5rem 2.5rem;*/
                height: 5rem;
                /*margin: auto;*/
                object-fit: contain
            }
            .intro-card-name {
                font-size: 0.85rem;
                font-weight: 400;
            }
        }

        .intro-card {
            text-decoration: none;
            color: black;
            margin-right: 2.5rem;
        }

        #intro-skill-card-wrapper, #intro-cert-card-wrapper {
            .intro-card {
                margin-bottom: 2.5rem;
            }
            .intro-card-image-container {
                width: 5rem;
            }
            .intro-card-image {
                width: 5rem;
                height: 6rem;
            }
            .intro-card-name {
                text-align: center;
            }
        }

        #self-intro-about {
            border-left: 1px solid var(--intro-tab-bg);
            .self-intro-title {
                font-size: 1.25rem;
                line-height: 1;
                font-weight: 400;
            }

            #self-intro-about-writeup {
                padding-bottom: 2rem;
                margin-bottom: 2rem;
                border-bottom: 1px solid var(--intro-tab-bg);
            }

            .self-intro-profile-item {
                width: 5rem;
                display: flex;
                align-items: center;
                flex-direction: column;
                .self-intro-profile-image-wrapper {
                    width: 3rem;
                    height: 3rem;
                    border-radius: 50%;
                    border: 1px solid var(--intro-tab-bg);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 0.25rem;
                }
                img {
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                }
            }
        }
    }

    .search-results {
        #intro-employment-card-wrapper {
            display: flex;
        }
        .intro-employment-detail-wrapper {
            margin-bottom: 2.25rem;
            .intro-employment-detail {
                .intro-employment-detail-company {
                    display: flex;
                    .intro-employment-detail-company-logo {
                        width: 1.5rem;
                        height: 1.5rem;
                        border-radius: 50%;
                    }
                    .intro-employment-detail-company-info {
                        display: flex;
                        flex-direction: column;
                        margin-left: 1rem;

                        .intro-employment-detail-company-name {
                            font-size: 0.85rem;
                            line-height: 1;
                            margin-bottom: 0.25rem
                        }
                        .intro-employment-detail-company-duration {
                            font-size: 0.8rem;
                            line-height: 1;
                        }
                    }
                }
            }
            .intro-employment-detail-company-role {
                padding-top: 0.25rem;
            }

            &.fun-facts {
                display: flex;
                margin-bottom: 2.5rem;

                .intro-employment-detail {
                    margin-right: 2rem;
                }
                img {
                    margin-left: auto;
                    margin-right: 0;
                    width: 7rem;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 10px;
                }
            }

            .intro-employment-detail-stack {
                font-weight: 500;
            }
        }
    }

    #pills-news {
        font-size: 0.9rem;
        line-height: 1rem;
        color: black;
        #search-text {
            font-weight: bold;
        }

        li {
            line-height: 1.5rem;
            display: list-item;
            text-align: -webkit-match-parent;
            unicode-bidi: isolate;
        }
    }

    #pills-video {
        .video-preview {
            width: 9rem;
            height: 6rem;
            margin-right: 2rem;
            border-radius: 0.5rem;
            flex-shrink: 0;
        }
    }
}

@media (max-width: 575.98px) {
    .video-title {
        max-width: 20rem !important;
    }
}
@media (max-width: 767.98px) {
    .video-title {
        max-width: 25rem !important;
    }
}
@media (max-width: 991.98px) {
    #search-wrapper {
        .input-group {
            width: 90vw;
        }
    }
    #header-wrapper {
        #logo {
            display: none;
        }
        .input-group {
            input {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-left: none;
            }
        }
    }

    #content-wrapper {
        & #self-intro-tab-content {
            #self-intro-about {
                border-left: none;
            }
            #self-intro-profile {
                padding-bottom: 2rem;
                margin-bottom: 2rem;
                border-bottom: 1px solid var(--intro-tab-bg);
            }
        }
    }
}

.footer {
    background: #f2f2f2;
    font-size: 0.7rem;
    font-weight: 400;
}
@media (max-width: 1199.98px) {
    #content-wrapper {
        #pills-tab, #pills-tabContent {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
    }
    .video-title {
        max-width: 40rem;
    }
}
@media (max-width: 1399.98px) {
    #age-info {
        margin-right: 0 !important;
        height: 50% !important;
    }
    #education-info {
        width: 100% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,uCAAuC;;IAEvC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;;IAEhB;QACI,qBAAqB;QACrB,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,kDAAkD;QAClD;YACI,sBAAsB;YACtB,kBAAkB;YAClB,4BAA4B;YAC5B,+BAA+B;YAC/B,cAAc;YACd,eAAe;YACf,iBAAiB;QACrB;;QAEA;YACI,2DAA2D;YAC3D,6BAA6B;YAC7B,gCAAgC;YAChC,cAAc;YACd;gBACI,cAAc;gBACd,kBAAkB;YACtB;;YAEA;gBACI,gBAAgB;YACpB;QACJ;;QAEA;YACI;gBACI,YAAY;gBACZ,gBAAgB;gBAChB,4BAA4B;gBAC5B,+BAA+B;;gBAE/B;oBACI,WAAW;oBACX,mBAAmB;gBACvB;YACJ;QACJ;;QAEA;;QAEA;IACJ;AACJ;;AAEA;IACI,iBAAiB;;IAEjB;QACI,6CAA6C;QAC7C,gBAAgB;;QAEhB;YACI,gBAAgB;YAChB,iBAAiB;YACjB,qBAAqB;YACrB,cAAc;YACd,kBAAkB;YAClB,mBAAmB;YACnB;gBACI,gBAAgB;gBAChB,4BAA4B;gBAC5B,cAAc;YAClB;QACJ;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,uCAAuC;QACvC,+BAA+B;QAC/B,6BAA6B;QAC7B,iBAAiB;QACjB;YACI,yBAAyB;QAC7B;IACJ;;IAEA;QACI,oBAAoB;;QAEpB;YACI,wBAAwB;QAC5B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,4CAA4C;QAChD;;QAEA;YACI,aAAa;YACb,uCAAuC;YACvC;gBACI,UAAU;gBACV;oBACI,WAAW;oBACX,YAAY;oBACZ,iBAAiB;gBACrB;YACJ;YACA;gBACI;oBACI,WAAW;gBACf;YACJ;;YAEA;gBACI,gDAAgD;gBAChD,mDAAmD;gBACnD,6BAA6B;YACjC;;YAEA;gBACI,iDAAiD;gBACjD,8BAA8B;YAClC;;YAEA;gBACI,oDAAoD;YACxD;QACJ;;QAEA;YACI;gBACI,kDAAkD;gBAClD,qCAAqC;gBACrC,aAAa;gBACb,kBAAkB;gBAClB,kBAAkB;gBAClB,wBAAwB,GAAG,gBAAgB;gBAC3C,qBAAqB,GAAG,YAAY;gBACpC;oBACI,YAAY;gBAChB;YACJ;YACA;gBACI,aAAa;YACjB;YACA;gBACI,WAAW;gBACX,WAAW;gBACX,iBAAiB;gBACjB,gDAAgD;gBAChD,iDAAiD;YACrD;QACJ;;QAEA;YACI,aAAa;;YAEb;gBACI,qBAAqB;gBACrB,OAAO;YACX;;YAEA;gBACI,2BAA2B;YAC/B;;YAEA;gBACI,WAAW;gBACX,gBAAgB;YACpB;YACA;gBACI,UAAU;gBACV,+BAA+B;gBAC/B,uCAAuC;gBACvC,sBAAsB;gBACtB;oBACI,gBAAgB;oBAChB,aAAa;oBACb,mBAAmB;gBACvB;;gBAEA;oBACI,cAAc;oBACd,gBAAgB;gBACpB;gBACA;oBACI,cAAc;oBACd,gBAAgB;gBACpB;YACJ;QACJ;;QAEA;YACI;gBACI;oBACI,yBAAyB;oBACzB,qBAAqB;gBACzB;YACJ;QACJ;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI;gBACI,aAAa;gBACb,eAAe;gBACf,sBAAsB;gBACtB,gBAAgB;gBAChB,WAAW;gBACX,gBAAgB;YACpB;YACA;gBACI,gBAAgB;gBAChB,WAAW;gBACX,sCAAsC;gBACtC,YAAY;gBACZ,gBAAgB;gBAChB;YACJ;YACA;gBACI,kBAAkB;gBAClB,gBAAgB;YACpB;QACJ;;QAEA;YACI,qBAAqB;YACrB,YAAY;YACZ,oBAAoB;QACxB;;QAEA;YACI;gBACI,qBAAqB;YACzB;YACA;gBACI,WAAW;YACf;YACA;gBACI,WAAW;gBACX,YAAY;YAChB;YACA;gBACI,kBAAkB;YACtB;QACJ;;QAEA;YACI,0CAA0C;YAC1C;gBACI,kBAAkB;gBAClB,cAAc;gBACd,gBAAgB;YACpB;;YAEA;gBACI,oBAAoB;gBACpB,mBAAmB;gBACnB,4CAA4C;YAChD;;YAEA;gBACI,WAAW;gBACX,aAAa;gBACb,mBAAmB;gBACnB,sBAAsB;gBACtB;oBACI,WAAW;oBACX,YAAY;oBACZ,kBAAkB;oBAClB,qCAAqC;oBACrC,aAAa;oBACb,uBAAuB;oBACvB,mBAAmB;oBACnB,sBAAsB;gBAC1B;gBACA;oBACI,WAAW;oBACX,YAAY;oBACZ,kBAAkB;gBACtB;YACJ;QACJ;IACJ;;IAEA;QACI;YACI,aAAa;QACjB;QACA;YACI,sBAAsB;YACtB;gBACI;oBACI,aAAa;oBACb;wBACI,aAAa;wBACb,cAAc;wBACd,kBAAkB;oBACtB;oBACA;wBACI,aAAa;wBACb,sBAAsB;wBACtB,iBAAiB;;wBAEjB;4BACI,kBAAkB;4BAClB,cAAc;4BACd;wBACJ;wBACA;4BACI,iBAAiB;4BACjB,cAAc;wBAClB;oBACJ;gBACJ;YACJ;YACA;gBACI,oBAAoB;YACxB;;YAEA;gBACI,aAAa;gBACb,qBAAqB;;gBAErB;oBACI,kBAAkB;gBACtB;gBACA;oBACI,iBAAiB;oBACjB,eAAe;oBACf,WAAW;oBACX,YAAY;oBACZ,mBAAmB;oBACnB,mBAAmB;gBACvB;YACJ;;YAEA;gBACI,gBAAgB;YACpB;QACJ;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,YAAY;QACZ;YACI,iBAAiB;QACrB;;QAEA;YACI,mBAAmB;YACnB,kBAAkB;YAClB,gCAAgC;YAChC,qBAAqB;QACzB;IACJ;;IAEA;QACI;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,qBAAqB;YACrB,cAAc;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI;QACI;YACI,WAAW;QACf;IACJ;IACA;QACI;YACI,aAAa;QACjB;QACA;YACI;gBACI,yBAAyB;gBACzB,4BAA4B;gBAC5B,iBAAiB;YACrB;QACJ;IACJ;;IAEA;QACI;YACI;gBACI,iBAAiB;YACrB;YACA;gBACI,oBAAoB;gBACpB,mBAAmB;gBACnB,4CAA4C;YAChD;QACJ;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI;QACI;YACI,oBAAoB;YACpB,qBAAqB;QACzB;IACJ;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["html {\n    --intro-tab-bg: #e5edff;\n    --intro-tab-color: #001d35;\n    --intro-card-radius: 2rem;\n    --divider-color: rgba(60, 64, 67, 0.25);\n\n    font-family: Arial, sans-serif;\n}\n\n#logo {\n    width: 7rem;\n    font-size: 1.5rem;\n    font-weight: 700;\n\n    span {\n        display: inline-block;\n        letter-spacing: 1px;\n    }\n}\n\n.google-blue {\n    color: #4285F4;\n}\n.google-red {\n    color: #EA4335;\n}\n.google-yellow {\n    color: #FBBC05;\n}\n.google-green {\n    color: #34A853;\n}\n\n#search-wrapper {\n    .input-group {\n        width: 50vw;\n        border-radius: 4rem;\n        box-shadow: 0px 2px 8px 0px rgba(60, 64, 67, 0.25);\n        input {\n            box-sizing: border-box;\n            padding-left: 1rem;\n            border-top-left-radius: 4rem;\n            border-bottom-left-radius: 4rem;\n            line-height: 2;\n            border-right: 0;\n            background: white;\n        }\n\n        #button-addon2 {\n            border: var(--bs-border-width) solid var(--bs-border-color);\n            border-top-right-radius: 4rem;\n            border-bottom-right-radius: 4rem;\n            border-left: 0;\n            #search-icon {\n                color: #4285f4;\n                margin-right: 1rem;\n            }\n\n            &:hover {\n                background: none;\n            }\n        }\n\n        #logo-prepend {\n            #basic-addon1 {\n                border: none;\n                background: none;\n                border-top-left-radius: 4rem;\n                border-bottom-left-radius: 4rem;\n\n                img {\n                    width: 2rem;\n                    object-fit: contain;\n                }\n            }\n        }\n\n        input, #button-addon2 {\n\n        }\n    }\n}\n\n#content-wrapper {\n    min-height: 100vh;\n\n    #pills-tab {\n        border-bottom: 1px solid var(--divider-color);\n        font-weight: 500;\n\n        .nav-link {\n            font-weight: 400;\n            font-size: 0.9rem;\n            text-decoration: none;\n            color: #70757a;\n            padding-left: 1rem;\n            padding-right: 1rem;\n            &.active {\n                font-weight: 600;\n                border-bottom-color: #1f1f1f;\n                color: #1f1f1f;\n            }\n        }\n    }\n\n    #pills-tabContent,   #pills-tab {\n        padding-left: 9rem;\n        padding-right: 9rem;\n    }\n\n    .intro-tab {\n        border-radius: var(--intro-card-radius);\n        background: var(--intro-tab-bg);\n        color: var(--intro-tab-color);\n        margin-left: 1rem;\n        &.active {\n            border: 1px solid #001d35;\n        }\n    }\n\n    #self-intro-tab-content {\n        padding-bottom: 2rem;\n\n        .fade:not(.show) {\n            display: none !important;\n        }\n\n        .active {\n            display: block;\n        }\n\n        #intro-home {\n            border-bottom: 1px solid var(--intro-tab-bg);\n        }\n\n        #image-container {\n            height: 20rem;\n            border-radius: var(--intro-card-radius);\n            #image-main, #image-sub {\n                width: 50%;\n                img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n            #image-sub {\n                img {\n                    height: 50%;\n                }\n            }\n\n            #first-image {\n                border-top-left-radius: var(--intro-card-radius);\n                border-bottom-left-radius: var(--intro-card-radius);\n                border-right: 3px solid white;\n            }\n\n            #second-image {\n                border-top-right-radius: var(--intro-card-radius);\n                border-bottom: 3px solid white;\n            }\n\n            #third-image {\n                border-bottom-right-radius: var(--intro-card-radius);\n            }\n        }\n\n        #general-info-container {\n            #instagram-wrapper {\n                border-radius: var(--intro-card-radius) !important;\n                border: 2px solid var(--intro-tab-bg);\n                height: 20rem;\n                overflow-y: scroll;\n                overflow-x: hidden;\n                -ms-overflow-style: none;  /* IE and Edge */\n                scrollbar-width: none;  /* Firefox */\n                > iframe {\n                    border: none;\n                }\n            }\n            &::-webkit-scrollbar {\n                display: none;\n            }\n            #card-image {\n                width: 100%;\n                height: 50%;\n                object-fit: cover;\n                border-top-left-radius: var(--intro-card-radius);\n                border-top-right-radius: var(--intro-card-radius);\n            }\n        }\n\n        #misc-info-container {\n            height: 20rem;\n\n            #age-info {\n                margin-right: 0.75rem;\n                flex: 1;\n            }\n\n            #age-info, #education-info {\n                height: calc(50% - 0.75rem);\n            }\n\n            #misc-info {\n                width: 100%;\n                overflow: hidden;\n            }\n            .info-card {\n                width: 50%;\n                background: var(--intro-tab-bg);\n                border-radius: var(--intro-card-radius);\n                margin-bottom: 0.75rem;\n                .info-title {\n                    font-weight: 500;\n                    margin-top: 0;\n                    margin-bottom: auto;\n                }\n\n                #age-info-years {\n                    line-height: 1;\n                    font-weight: 600;\n                }\n                #age-info-dob {\n                    line-height: 1;\n                    font-weight: 400;\n                }\n            }\n        }\n\n        #intro-home {\n            &.active  + #non-overview-content-wrapper{\n                #intro-employment {\n                    display: block !important;\n                    opacity: 1 !important;\n                }\n            }\n        }\n\n        .intro-tab-title {\n            font-weight: 400;\n        }\n\n        .intro-card-wrapper {\n            .intro-card-image-container {\n                display: flex;\n                flex-wrap: wrap;\n                flex-direction: column;\n                max-width: 10rem;\n                width: 100%;\n                text-align: left;\n            }\n            .intro-card-image {\n                max-width: 10rem;\n                width: 100%;\n                /*padding: 1rem 2.5rem 0.5rem 2.5rem;*/\n                height: 5rem;\n                /*margin: auto;*/\n                object-fit: contain\n            }\n            .intro-card-name {\n                font-size: 0.85rem;\n                font-weight: 400;\n            }\n        }\n\n        .intro-card {\n            text-decoration: none;\n            color: black;\n            margin-right: 2.5rem;\n        }\n\n        #intro-skill-card-wrapper, #intro-cert-card-wrapper {\n            .intro-card {\n                margin-bottom: 2.5rem;\n            }\n            .intro-card-image-container {\n                width: 5rem;\n            }\n            .intro-card-image {\n                width: 5rem;\n                height: 6rem;\n            }\n            .intro-card-name {\n                text-align: center;\n            }\n        }\n\n        #self-intro-about {\n            border-left: 1px solid var(--intro-tab-bg);\n            .self-intro-title {\n                font-size: 1.25rem;\n                line-height: 1;\n                font-weight: 400;\n            }\n\n            #self-intro-about-writeup {\n                padding-bottom: 2rem;\n                margin-bottom: 2rem;\n                border-bottom: 1px solid var(--intro-tab-bg);\n            }\n\n            .self-intro-profile-item {\n                width: 5rem;\n                display: flex;\n                align-items: center;\n                flex-direction: column;\n                .self-intro-profile-image-wrapper {\n                    width: 3rem;\n                    height: 3rem;\n                    border-radius: 50%;\n                    border: 1px solid var(--intro-tab-bg);\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    margin-bottom: 0.25rem;\n                }\n                img {\n                    width: 2rem;\n                    height: 2rem;\n                    border-radius: 50%;\n                }\n            }\n        }\n    }\n\n    .search-results {\n        #intro-employment-card-wrapper {\n            display: flex;\n        }\n        .intro-employment-detail-wrapper {\n            margin-bottom: 2.25rem;\n            .intro-employment-detail {\n                .intro-employment-detail-company {\n                    display: flex;\n                    .intro-employment-detail-company-logo {\n                        width: 1.5rem;\n                        height: 1.5rem;\n                        border-radius: 50%;\n                    }\n                    .intro-employment-detail-company-info {\n                        display: flex;\n                        flex-direction: column;\n                        margin-left: 1rem;\n\n                        .intro-employment-detail-company-name {\n                            font-size: 0.85rem;\n                            line-height: 1;\n                            margin-bottom: 0.25rem\n                        }\n                        .intro-employment-detail-company-duration {\n                            font-size: 0.8rem;\n                            line-height: 1;\n                        }\n                    }\n                }\n            }\n            .intro-employment-detail-company-role {\n                padding-top: 0.25rem;\n            }\n\n            &.fun-facts {\n                display: flex;\n                margin-bottom: 2.5rem;\n\n                .intro-employment-detail {\n                    margin-right: 2rem;\n                }\n                img {\n                    margin-left: auto;\n                    margin-right: 0;\n                    width: 7rem;\n                    height: 100%;\n                    object-fit: contain;\n                    border-radius: 10px;\n                }\n            }\n\n            .intro-employment-detail-stack {\n                font-weight: 500;\n            }\n        }\n    }\n\n    #pills-news {\n        font-size: 0.9rem;\n        line-height: 1rem;\n        color: black;\n        #search-text {\n            font-weight: bold;\n        }\n\n        li {\n            line-height: 1.5rem;\n            display: list-item;\n            text-align: -webkit-match-parent;\n            unicode-bidi: isolate;\n        }\n    }\n\n    #pills-video {\n        .video-preview {\n            width: 9rem;\n            height: 6rem;\n            margin-right: 2rem;\n            border-radius: 0.5rem;\n            flex-shrink: 0;\n        }\n    }\n}\n\n@media (max-width: 575.98px) {\n    .video-title {\n        max-width: 20rem !important;\n    }\n}\n@media (max-width: 767.98px) {\n    .video-title {\n        max-width: 25rem !important;\n    }\n}\n@media (max-width: 991.98px) {\n    #search-wrapper {\n        .input-group {\n            width: 90vw;\n        }\n    }\n    #header-wrapper {\n        #logo {\n            display: none;\n        }\n        .input-group {\n            input {\n                border-top-left-radius: 0;\n                border-bottom-left-radius: 0;\n                border-left: none;\n            }\n        }\n    }\n\n    #content-wrapper {\n        & #self-intro-tab-content {\n            #self-intro-about {\n                border-left: none;\n            }\n            #self-intro-profile {\n                padding-bottom: 2rem;\n                margin-bottom: 2rem;\n                border-bottom: 1px solid var(--intro-tab-bg);\n            }\n        }\n    }\n}\n\n.footer {\n    background: #f2f2f2;\n    font-size: 0.7rem;\n    font-weight: 400;\n}\n@media (max-width: 1199.98px) {\n    #content-wrapper {\n        #pills-tab, #pills-tabContent {\n            padding-left: 1.5rem;\n            padding-right: 1.5rem;\n        }\n    }\n    .video-title {\n        max-width: 40rem;\n    }\n}\n@media (max-width: 1399.98px) {\n    #age-info {\n        margin-right: 0 !important;\n        height: 50% !important;\n    }\n    #education-info {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
